// extracted by mini-css-extract-plugin
module.exports = {"quantityText":"Types_quantityText__3JVKi","assemblyCheckbox":"Types_assemblyCheckbox__1TXlW"};